import "dotenv/config";

console.log(process.env.REACT_APP_MODE)

export default {
  API_URL: process.env.REACT_APP_API_URL,
  getGeoInfo: process.env.REACT_APP_getGeoInfo,
  BASE_NAME: process.env.REACT_APP_BASE_NAME,
}
